import { Component, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "app-root",
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  /** Passive:false so preventDefault can block wheel-bumping number inputs (HAN-406). */
  private readonly blockNumberInputWheel = (event: WheelEvent): void => {
    const target = event.target;
    if (target instanceof HTMLInputElement && target.type === "number") {
      event.preventDefault();
    }
  };

  ngOnInit(): void {
    document.addEventListener("wheel", this.blockNumberInputWheel, { passive: false });
  }

  ngOnDestroy(): void {
    document.removeEventListener("wheel", this.blockNumberInputWheel);
  }
}
